import { GROUND_ROW, fillRect, freeze, makeGrid, setCell, type EntitySpawn, type LevelDef } from "./types";

export function buildWorld13(): LevelDef {
  const width = 176;
  const grid = makeGrid(width, false);
  const entities: EntitySpawn[] = [];
  const pipes: LevelDef["pipes"] = [];

  fillRect(grid, 0, GROUND_ROW, 8, 2, "=");
  fillRect(grid, 168, GROUND_ROW, 8, 2, "=");

  const treetop = (tx: number, ty: number, w: number): void => {
    fillRect(grid, tx, ty, w, 1, "-");
    if (w >= 3) setCell(grid, tx + Math.floor(w / 2), ty + 1, "M");
  };

  treetop(10, 10, 4);
  treetop(16, 8, 5);
  treetop(24, 6, 4);
  treetop(30, 9, 6);
  treetop(40, 7, 5);
  treetop(48, 11, 3);
  treetop(54, 8, 4);
  treetop(62, 5, 6);
  treetop(72, 9, 5);
  treetop(80, 6, 4);
  treetop(88, 8, 7);
  treetop(98, 10, 4);
  treetop(106, 7, 5);
  treetop(116, 5, 4);
  treetop(124, 8, 6);
  treetop(134, 6, 5);
  treetop(144, 9, 4);
  treetop(152, 7, 6);
  fillRect(grid, 160, GROUND_ROW - 1, 4, 1, "-");

  for (let x = 8; x < 20; x += 4) setCell(grid, x, 3, "O");
  for (let x = 40; x < 70; x += 8) setCell(grid, x, 2, "O");
  setCell(grid, 100, 3, "O");
  setCell(grid, 130, 2, "O");

  entities.push({ kind: "platform", tx: 36, ty: 8, tiles: 3, axis: "x", span: 5 });
  entities.push({ kind: "scale", left: 84, right: 94, ty: 6, tiles: 3 });
  entities.push({ kind: "platform", tx: 112, ty: 9, tiles: 2, axis: "y", span: 4 });

  entities.push({ kind: "walker", tx: 18, ty: 8 });
  entities.push({ kind: "walker", tx: 32, ty: 9 });
  entities.push({ kind: "troopa", tx: 42, ty: 7, color: "red" });
  entities.push({ kind: "walker", tx: 56, ty: 8 });
  entities.push({ kind: "troopa", tx: 64, ty: 5, color: "red" });
  entities.push({ kind: "walker", tx: 90, ty: 8 });
  entities.push({ kind: "walker", tx: 108, ty: 7 });
  entities.push({ kind: "troopa", tx: 126, ty: 8, color: "green" });
  entities.push({ kind: "walker", tx: 146, ty: 9 });
  entities.push({ kind: "troopa", tx: 154, ty: 7, color: "red" });

  fillRect(grid, 164, GROUND_ROW - 8, 1, 8, "F");
  setCell(grid, 164, GROUND_ROW - 9, "G");
  fillRect(grid, 169, GROUND_ROW - 5, 5, 5, "C");
  setCell(grid, 171, GROUND_ROW - 2, "D");

  return {
    id: "1-3",
    worldLabel: "1-3",
    theme: "athletic",
    time: 300,
    tiles: freeze(grid),
    entities,
    pipes,
    playerSpawn: { tx: 3, ty: GROUND_ROW },
    flagX: 164,
    castleX: 169,
    next: "1-4",
  };
}
